var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-stack',{staticClass:"deviceMsgFooter",attrs:{"justify-content":"space-between"}},[_c('div',{staticClass:"deviceRssi"},[_vm._v(" "+_vm._s(_vm.rssi)+" ")]),_c('div',{staticClass:"deviceTimer"},[_vm._v(" "+_vm._s(_vm.timeStr)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }